import { Component, OnInit, OnDestroy } from '@angular/core';
import { Organization } from '../../../models/organization';
import { Observable } from 'rxjs';
import { OrganizationsService } from '../../organizations.service';
import { countryMap, regionMap } from '../../../util/geography';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { EntityDetailsPageComponent } from 'src/app/util/entity-details-page.component';
import { EntityDetailsPageService } from 'src/app/util/entity-details-page.service';
import { MatDialog } from '@angular/material/dialog';
import { ActionConfirmationService } from 'src/app/util/confirmation/confirmation.service';

@Component({
  selector: 'app-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss'],
  providers: [
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: { clickAction: 'noop' },
    },
    EntityDetailsPageService,
  ],
})
export class OrganizationDetailsComponent
  extends EntityDetailsPageComponent<Organization>
  implements OnInit, OnDestroy
{
  countryMap = countryMap;
  regionMap = regionMap;
  baseTitle = 'Organization Details';

  constructor(
    private organizationService: OrganizationsService,
    detailsService: EntityDetailsPageService<Organization>,
    dialog: MatDialog
  ) {
    super(
      detailsService,
      organizationService,
      new ActionConfirmationService(dialog)
    );
  }

  getTitle(org: Organization): string {
    return org.name;
  }

  loadEntity(): Observable<Organization> {
    return this.organizationService.getEntity();
  }

  namespace(): string {
    return 'organization-details.component';
  }
}
